{
	"name": "@cloudillo/shell",
	"version": "0.8.20",
	"private": true,
	"description": "Cloudillo shell",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"l-scan": "i18next-scanner --config src/i18n/scanner.config.cjs",
		"ts": "tsgo --noEmit && tsgo --noEmit -p sw/tsconfig.json",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"dev": "node esbuild.config.js --watch",
		"test": "NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"clean": "rimraf .cache dist/assets* dist/fonts dist/index.html* dist/manifest.json* dist/offline.html* dist/shell-apps.json* dist/sw*",
		"start": "web-dev-server"
	},
	"author": "Szilárd Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/calendar-ui": "workspace:^",
		"@cloudillo/core": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@cloudillo/types": "workspace:^",
		"@emoji-mart/data": "^1.2.1",
		"@emoji-mart/react": "^1.1.1",
		"@jest/globals": "^30.5.2",
		"@popperjs/core": "^2.11.8",
		"@simplewebauthn/browser": "^14.0.0",
		"@symbion/opalui": "^0.16.0",
		"@symbion/runtype": "^1.3.1",
		"@testing-library/dom": "^10.4.2",
		"@testing-library/react": "^16.3.3",
		"@types/debounce": "^1.2.4",
		"@types/jest": "^30.0.0",
		"@types/node": "^26.6.5",
		"@types/qrcode": "^1.5.6",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"@types/turndown": "^5.0.6",
		"cross-env": "^10.1.0",
		"dayjs": "^1.11.23",
		"debounce": "^3.0.0",
		"downshift": "^9.4.0",
		"esbuild": "^0.28.2",
		"i18next": "^26.5.2",
		"i18next-browser-languagedetector": "^8.2.1",
		"i18next-scanner": "^4.6.0",
		"i18next-scanner-typescript": "^1.2.1",
		"jest": "^30.5.2",
		"jest-environment-jsdom": "^30.5.2",
		"jotai": "^3.0.1",
		"qr-scanner": "^1.4.2",
		"quick-lru": "^7.3.0",
		"quill": "^2.0.3",
		"quilljs-markdown": "^1.2.0",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-i18next": "^17.1.0",
		"react-icons": "^5.7.0",
		"react-markdown": "^10.1.0",
		"react-photo-album": "^3.6.2",
		"react-popper": "^2.3.0",
		"react-qr-code": "^2.2.0",
		"react-quill-new": "^3.8.3",
		"react-router-dom": "^7.18.4",
		"rimraf": "^6.1.3",
		"rrule": "^2.8.1",
		"ts-jest": "^29.4.15",
		"tslib": "^2.8.1",
		"turndown": "^7.2.4",
		"typescript": "npm:@typescript/typescript6@^6.0.2",
		"yet-another-react-lightbox": "^3.32.2"
	},
	"dependencies": {
		"marked": "^18.1.1",
		"pdfjs-dist": "^6.4.299"
	}
}
